import { AT_A_GLANCE } from "../../lib/data";

export const AtAGlance = () => {
  return (
    <section
      id="glance"
      data-testid="glance-section"
      className="hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-4">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              01 — At a Glance
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95]">
              The numbers,<br />unedited.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
            <p className="text-base md:text-lg leading-relaxed text-[var(--muted)] max-w-prose">
              A snapshot of business managed, growth delivered, and people led
              across eight years of integrated marketing.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 hairline border-l border-t">
          {AT_A_GLANCE.map((stat, i) => (
            <div
              key={stat.label}
              data-testid={`kpi-${i}`}
              className="hairline border-r border-b p-6 md:p-8 reveal"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-6 md:mb-10">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="font-mono text-4xl md:text-6xl font-medium tracking-tighter leading-none">
                {stat.value}
              </div>
              <div className="mt-4 md:mt-6 text-xs md:text-sm font-medium tracking-tight text-[var(--ink)]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
